import { Box, Paper, Typography } from "@mui/material";
import useBatteryDistributionPreview from "../../hooks/useBatteryDistributionPreview";
import {
  BatteryDistributionAfter,
} from "./BatteryDistributionCard/BatteryDistributionAfter";
import useMoveVirtualBatteryContext from "../MoveVirtualBattery/useMoveVirtualBatteryContext";
import { useContracts } from "@/components/Contracts/hooks/useContracts";
import { useTranslation } from "react-i18next";
import { FC } from "react";

interface MoveBatteryDistributionPreviewParams {
  newPercentage: number;
  selectedBatteryId: number;
}

export const MoveBatteryDistributionPreview: FC<MoveBatteryDistributionPreviewParams> = ({
  newPercentage,
  selectedBatteryId,
}) => {
  const { t } = useTranslation();
  const { 
    bateriaVirtualToMove, 
    selectedBatteryDistribution 
  } = useMoveVirtualBatteryContext();

  const { currentContract } = useContracts("electricity");
  const { getExpectedDistribution } = useBatteryDistributionPreview();

  const oldExpectedDistribution = getExpectedDistribution({
    expectedAction: "removed",
    targetBatteryId: bateriaVirtualToMove!.bateria.id,
    removedContractId: currentContract.id,
  });
  const newExpectedDistribution = getExpectedDistribution({
    expectedAction: "move",
    movedBatteryId: selectedBatteryId,
    newPercentage,
    forceCurrentName: currentContract.name
  });

  return (
    <>
      <Box>
        <Typography variant="h6">
          {t("common:text.solar_wallet.move.status_after_confirmation")}
        </Typography>
        <Paper
          style={{
            padding: "1rem",
            overflowY: "auto",
            maxHeight: "35vh",
          }}
          variant="outlined"
        >
          <Box style={{ position: "relative" }}>
            <Typography variant="subtitle2">

              {t("common:text.solar_wallet.move.title")} <u>{t("common:text.solar_wallet.move.destination")}</u>:
              { selectedBatteryDistribution!["batteryName"] }
            </Typography>
            <BatteryDistributionAfter
              batteryDistribution={newExpectedDistribution}
            />
            <hr />
            <Typography variant="subtitle2">
              {t("common:text.solar_wallet.move.title")} <u>{t("common:text.solar_wallet.move.current")}</u>:
              {bateriaVirtualToMove!["bateria"]["name"]}
            </Typography>
            <BatteryDistributionAfter
              batteryDistribution={oldExpectedDistribution}
            />
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default MoveBatteryDistributionPreview;
